import { render, staticRenderFns } from "./ShoppingCartTypeHeader.vue?vue&type=template&id=0c52b2a3&scoped=true&"
import script from "./ShoppingCartTypeHeader.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartTypeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c52b2a3",
  null
  
)

export default component.exports